import { ReactNode } from 'react';
import {
  CircularProgress,
  CircularProgressProps,
  Stack,
} from '@rossum/ui/material';
import { borderRadius } from '@rossum/ui/theme';

type WrapperProps = {
  children: ReactNode;
};
const Wrapper = ({ children }: WrapperProps) => {
  return (
    <Stack
      sx={{
        alignItems: 'center',
        justifyContent: 'center',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        borderRadius: borderRadius('l'),
        backgroundColor: theme =>
          theme.palette.mode === 'dark'
            ? 'rgba(27, 25, 34, 0.8)'
            : 'rgba(255, 255, 255, 0.8)',
        zIndex: 1,
      }}
    >
      {children}
    </Stack>
  );
};

const LoadingOverlay = ({ color, size }: CircularProgressProps) => {
  return (
    <Wrapper>
      <CircularProgress color={color} size={size} />
    </Wrapper>
  );
};

export { LoadingOverlay };
